export default __webpack_public_path__ + "static/media/enlarge.6b66e60d.svg";